import './midohiofoodbank/style';
import FormStructure from './midohiofoodbank/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js